<template>
  <vs-dropdown vs-trigger-click class="cursor-pointer items-per-page-handler">
    <div
      class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
    >
      <span
        class="mr-2"
      >{{ this.currentPage * this.itemsPerPage - (this.itemsPerPage - 1) }} - {{ this.totalCount - this.currentPage * this.itemsPerPage > 0 ? this.currentPage * this.itemsPerPage : this.totalCount }} {{$t('Of')}} {{ queriedItems }}</span>
      <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
    </div>
    <vs-dropdown-menu>
      <vs-dropdown-item :key="pageSize" v-for="pageSize in this.pageSizes" @click="updateItemPerPage(pageSize)">
        <span>{{pageSize}}</span>
      </vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
export default {
  name: "pager",
  props: {
    currentPage: Number,
    itemsPerPage: Number,
    totalCount: Number,
    queriedItems: Number,
    pageSizes: Array

  },
  data() {
    return {
      err: false,
      vm: null,
      info: null
    };
  },
  methods: {
    updateItemPerPage(value) {
      this.$emit("pageChanged", value);
    }
  }
};
</script>

